var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center container-geral",style:(("overflow: " + _vm.overflow))},[_c('div',{staticClass:"container-components"},[_c('Accounting')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }